module.exports = __webpack_public_path__ + "img/3d23fc5.jpg";